import * as React from "react";
import { LIME } from "@transitions_dev/look-into-my-eyes";
/* empty css             */
const TransitionColors = [
  "Amethyst",
  "Amber",
  "Brown",
  "Grey",
  "Emerald",
  "Graphite-Green",
  "Sapphire",
  "Red-Mirrored",
  "Silver-Mirrored",
  "Green-Mirrored",
  "Gold-Mirrored",
  "Pink-Mirrored",
  "Blue-Mirrored",
  "Amber-Gen-S",
  "Amethyst-Gen-S",
  "Brown-Gen-S",
  "Emerald-Gen-S",
  "Graphite-Green-Gen-S",
  "Grey-Gen-S",
  "Sapphire-Gen-S",
  "Ruby-Gen-S"
];
const LimeWrapper = ({
  frameSrc,
  frameUPC,
  lensColor,
  transitionType = "signature",
  onSuccess,
  onError
}) => /* @__PURE__ */ React.createElement("div", { id: "tfpa-loader", className: "tfpa-loader" }, /* @__PURE__ */ React.createElement(
  LIME,
  {
    frameSrc,
    generateMask: "1",
    lensColor,
    upc: `upc-${frameUPC}`,
    integrator: "grandvisioncom",
    transitionsType: transitionType,
    onSuccess,
    onError,
    containerId: "tfpa-loader",
    showLoading: "true",
    spinnerColor: "#C0C0C0",
    showLogo: "1"
  }
));
export {
  LimeWrapper,
  TransitionColors
};
//# sourceMappingURL=wrapper.js.map
